export const BASE_URL_TRASPASO = process.env.GATSBY_BASE_URL_TRASPASO
export const PREFIX_REPOSITORY = process.env.GATSBY_PREFIX_REPOSITORY_FILE
export const POSTFIX_REPOSITORY = process.env.GATSBY_POSTFIX_REPOSITORY_FILE
export const RECAPTCHA_KEY = process.env.GATSBY_RECAPTCHA_KEY
export const RECAPTCHA_INVISIBLE_KEY = process.env.GATSBY_RECAPTCHA_INVISIBLE_KEY
export const QAMALEON_RECAPTCHA_KEY = process.env.GATSBY_QAMALEON_RECAPTCHA_KEY
export const PATH_PREFIX = process.env.GATSBY_PATH_PREFIX
export const MOSTRAR_CHAT = process.env.GATSBY_MOSTRAR_CHAT
export const RECAPTCHA_AHORROYA_INVISIBLE_KEY = process.env.GATSBY_RECAPTCHA_AHORROYA_INVISIBLE_KEY
